var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-tile-control"},[_c('custom-expansion-panel',{attrs:{"data":[_vm.panelData]},on:{"change":_vm.callback}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }